export const Consts = {
  HEIGHT_MIN: 30.0,
  HEIGHT_MAX: 220.0,
  HEIGHT_DEFAULT: 160.0,
  WEIGHT_DEFAULT: 60.0,
  WEIGHT_MIN: 5.0,
  WEIGHT_MAX: 300.0,
  HEIGHT: "height",
  WEIGHT: "weight",
  KG: "kg",
  CM: "cm",
  NOT: "not",
  CHAPTER: "chapter",
  BLOCK: "block",
  CATEGORY: "category",
  DAY_TIMES: "dayTimes",
  DAYS: "day(s)",
  TIMES: "times",
  MORNING: "morning",
  NOON: "noon",
  EVENING: "evening",
  NIGHT: "night",
  REGULARLY: "regularly",
  ON_DEMAND: "on_demand",
  INTAKE_TIME_OPTIONS: "intake kind options",
  FREQUENCY_UNIT: "frequencyUnit",
  STRENGTH_UNIT: "strengthUnit",
  DOSAGE: "dosage",
  TIME: "time",
  PRODUCT: "product",
  SUBSTANCE: "substance",
  MANUALLY: "manually",
  UPLOAD: "upload",
  PZN: "PZN",
  ATTACHMENT: "attachment",
  DEFAULT_MORNING_INTAKE_TIME: "08:00",
  DEFAULT_NOON_INTAKE_TIME: "13:00",
  DEFAULT_EVENING_INTAKE_TIME: "18:00",
  DEFAULT_NIGHT_INTAKE_TIME: "23:00",
  DEFAULT_DAY_TIME_INTAKES: [
    {
      timeName: "morning",
      intakeTime: "08:00",
      dosage: 0,
      dosageUnit: ""
    },
    {
      timeName: "noon",
      intakeTime: "13:00",
      dosage: 0,
      dosageUnit: ""
    },
    {
      timeName: "evening",
      intakeTime: "18:00",
      dosage: 0,
      dosageUnit: ""
    },
    {
      timeName: "night",
      intakeTime: "23:00",
      dosage: 0,
      dosageUnit: ""
    }
  ],
  DAY_TIME_INDEX_MAP: {
    ["morning"]: 0,
    ["noon"]: 1,
    ["evening"]: 2,
    ["night"]: 3,
  },
  DEFAULT_DAY_TIMES: [
    "08:00",
    "13:00",
    "18:00",
    "23:00",
  ],
  DAY_TIME_NAMES: [
    "morning",
    "noon",
    "evening",
    "night",
  ],
  ALL_GENE_NAMES: ["CYP2C9", "CYP2C19", "CYP2D6", "SLCO1B1", "ABCG2", "CFTR", "COMT", "CYP1A2", "CYP2B6", "CYP2C8", "CYP3A4", "CYP3A5", "DPYD", "HLA-A", "HLA-B", "HLA-B44", "MTHFR", "NAT2", "NUDT15", "TPMT", "UGT1A1", "VKORC1"],
  ANDERS_GENES: ["CYP2C9", "UGT1A1"],
  PATIENT_INITIAL_GENES: ["CYP2C9", "CYP2C19", "CYP2D6", "SLCO1B1"],
  PATIENT: "patient",
  PATIENTS: "patients",
  USER_ID: "userId",
  PHENO_RISKS: "phenoRisks",
  GENO_RISKS: "genoRisks",
  COMPLETE_RISKS: "completeRisks",
  INTERMEDIATE_METABOLIZER: "Intermediate metabolizer",
  POOR_METABOLIZER: "Poor metabolizer",
  INTERMEDIATE_FUNCTION: "Intermediate function",
  POOR_FUNCTION: "Poor function",
  NORMAL_FUNCTION: "Normal function",
  NOT_CYP2C9_INTERMEDIATE_GENOS: ["*1/*2", "*1/*3", "*2/*5"],
  NOT_CYP2C9_POOR_GENOS: ["*2/*2", "*2/*3", "*3/*3", "*2/*6"],
  NOT_UGT1A1_GENOS: ["*1/*28", "*28/*28"],
  NEVER: "never",
  ANY: "any",
  YES: "yes",
  FILE: "file",
  FILES: "files",
  OTHER: "other",
  ACTIVE: "active",
  DEFAULT_DRUG_START: "2025-01-29",
  DEFAULT_DISEASE_START: "2025-01-29",
  ALL_DISEASES: "AllDiseases",
  DISEASES: "diseases",
  DISEASE: "disease",
  ADD: "add",
  REMOVE: "remove",
  PGX: "pgx",
  PGX_GENES: "pgxGenes",
  PGX_SELECTED_GENES: "pgxSelectedGenes",
  ALCOHOL: "alcohol",
  WEIGHT_HEIGHT: "weightHeight",
  DRUGS: "drugs",
  SUMMARY: "summary",
  END: "end",
  GENDER: "gender",
  FINISH: "finish",
  BACK: "back",
  NEXT: "next",
  PUT: "PUT",
  MEASUREMENT: "measurement",
  GENE_TEST: "genetest",
  INTERACTION: "interaction",
  INTERACTIONS: "interactions",
  DRUG: "drug",
  BMP: "bmp",
  CREATE: "create",
  TABLE: "table",
  GRAPH: "graph",
  HCP: "hcp",
  STUDY: "study",
  PLASMA: "plasma",
  STUDY_DIRECTOR: "studydirector",
  HCP_PRESCRIBER: "hcpprescriber",
  HOSPITAL: "hospital",
  SYMPTOMS: "symptoms",
  SYMPTOM: "symptom",
  MEASUREMENTS: "measurements",
  LAB_TESTS: "lab_tests",
  DATE_OF_BIRTH: "date_of_birth",
  MED_PLAN: "medication_plan",
  TOKEN: "token",
  ROLE: "role",
  NAME: "name",
  DELETE: "DELETE",
  YELLOW: "yellow",
  RED: "red",
  GREY: "grey",
  ORANGE: "orange",
  TRANSPARENT: "transparent",
  WHITE: "white",
  POST: "POST",
  GET: "GET",
  NONE: "none",
  TEST_DATE: "testDate",
  DATE_TIME: "dateTime",
  LAB_TEST_NAME: "labTestName",
  ROOT: "root",
  DAY: "day",
  CIRCLE: "circle",
  RECT: "rect",
  RESIZE: "resize",
  BOOLEAN: "boolean",
  API_IFRAME: "appIframe",
  BROWSE: "browse",
  NUMBER: "number",
  VALUE: "value",
  UNIT: "unit",
  PHENO: "PHENO",
  GENO: "GENO",
  TEXT: "text",
  HOURS: "hours",
  LAB: "lab",
  USERNAME: "username",
  PASSWORD: "password",
  APPLICATION_JSON: "application/json",
  POOR_521CC: "521CC",
  INTERMEDIATE_521TC: "521T",
  SAVE: "Save",
  CONFIRMED: "confirmed",
  DATE: "date",
  ETHNICITY_STUDY: "University Hospital of RWTH Aachen",
  ETHNICITY_STUDY2: "University Hospital of Patras",
  DEMO_HOSPITAL: "Demo-hospital",
  ACTIVE_SUBSTANCES: "activeSubstances",
  NOT_SPECIFIED: "not_specified",
  SEARCH: "search",
  FREE_TEXT: "freeText",
  NOT_AVAILABLE: "not_available"
}

export const colors = [
  "#008000",
  "#008000",
  "#2ac719",
  "#FFA500",
  "#FF0000",
  "#c00006",
];